import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from 'react-router-dom';

import LoginRoute from './components/LoginRoute';
import AuthRoute from './components/AuthRoute';
import MainRoute from './components/MainRoute';
import LocalStorage from './LocalStorage';

import './App.css';

const store = LocalStorage.instance;

function App() {

  return (
    <Router>
      <Switch>
        <Route path='/auth'><AuthRoute /></Route>
        <Route path='/main'><MainRoute /></Route>
        <Route path='/'><LoginRoute /></Route>
      </Switch>
    </Router>
  );
}

export default App;
